export default "__VITE_ASSET__DdvMQ4IN__"